import { BaseModel } from './BaseModel';
import { ServerTemplateTask } from './ServerTemplateTask';

export class ServerTemplateSchedule extends BaseModel {
    public id = '';
    public name = '';
    public cron = {
        minute: '',
        hour: '',
        dayOfWeek: '',
        dayOfMonth: '',
    };
    public isActive = false;
    public isManaged = false;
    public userCanToggle = false;
    public spreadWindow: number | null = null;
    public createdAt = '';
    public updatedAt = '';

    get tasks(): ServerTemplateTask[] {
        return this.getRelationship('tasks') || [];
    }

    getRouteName() {
        return 'serverTemplateSchedule';
    }

    getRouteID(): string {
        return this.id;
    }
}
